import React, { useEffect, useState } from 'react';
import { css } from 'aphrodite';

import Card from '~/src/components/Card';

import styles from '../styles';
import { SubscriptionDetails } from './SubscriptionDetails';

const SettingsSubscription = (props) => {
  const { subscription } = props;

  const [pendingRequest, setPendingRequest] = useState(false);

  useEffect(() => {
    setPendingRequest(false);
  }, []);

  return (
    <div>
      {subscription ? (
        <SubscriptionDetails
          pendingRequest={pendingRequest}
          subscription={subscription}
        />
      ) : (
        <Card elevate className={css(styles.settingsCardContainer)}>
          <>
            You have no active subscription. To enquire about your subscription,
            please contact Clio support.
          </>
        </Card>
      )}
    </div>
  );
};

export const SettingsCbsSubscription = SettingsSubscription;
